<template>
    <app-container class="about-page">
        <about-header/>
        <div class="about-page__content">
          <div class="about-page__explain">
              <h2>版权说明</h2>
              <p>本站采用「署名 4.0 国际（CC BY 4.0）」创作共享协议</p>
              <p>对本站所有原创内容进行转载、节选、混编、二次创作，商业性使用需署名并标明出处</p>
          </div>

            <div class="about-page__contact">
                <app-button href="mailto:hirozhuz@gmail.com">
                    <app-icon value="icon-email"/>
                </app-button>
                <app-button href="https://github.com/hirozhuz"
                            target="_blank"
                >
                    <app-icon value="icon-git"/>
                </app-button>
                <app-button href="https://juejin.im/user/2735240658563214"
                            target="_blank"
                >
                    <app-icon value="icon-juejin"/>
                </app-button>
            </div>
        </div>
    </app-container>
</template>

<script>
    import AppContainer from '@components/AppContainer'
    import AppButton from '@components/AppButton'
    import AppIcon from '@components/AppIcon'
    import AboutHeader from './components/Header'


    export default {
        name: "About",
        components: {
            AppIcon,
            AppButton,
            AppContainer,
            AboutHeader
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";

    .about-page {
        padding: $paddingSP*2 $paddingMD $paddingSP;
        max-width: 800px;

        &__explain{
            h2{
                line-height: 1.5;
                font-size: $fontSizeMD;
                font-weight: $fontWeightBolder;
                margin-bottom: $paddingMD;
            }
            p{
                line-height: 1.5;
                text-indent: 2em;
                margin-bottom: $paddingBase;
            }
        }

        &__contact {
            margin-top: $paddingSP;
            .app-button:not(:last-child){
                margin-right: $paddingMD;
                font-size: $fontSizeLG;
            }
            .iconfont{
                font-size: $fontSizeMD;
            }
        }
    }
</style>